import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import { prefetchInfiniteReviews } from 'querys/reviews'
import Navigation from 'components/navigation'
import OpenGraph from 'common/open-graph'
import Footer from 'common/footer'
import Opinions from 'components/opinions/opinions-carousel'
import InfiniteReviews from 'components/opinions/infinite-reviews'
import PlanetSection from 'home/planet-section'
import FreeLesson from 'home/free-lesson'
import { prefetchTotalUsers } from 'querys/growth'

function Opiniones() {
  return (
    <>
      <OpenGraph
        title="Opiniones de estudiantes"
        url="https://leonidasesteban.com/opiniones"
        keyword="Opiniones de Leonidas Esteban, Cursos de programacion, Cursos de Desarrollo Web, Cursos de React"
        description="Estas son las opiniones de miles de estudiantes al tomar los cursos de LeonidasEsteban.com"
        image="/images/open-graph/opiniones-de-leonidas-esteban.jpg"
      />
      <Navigation background="var(--sky)" />
      <Opinions />
      <InfiniteReviews />
      <FreeLesson />
      <PlanetSection />
      <Footer background="var(--darkBlue)" />
    </>
  )
}

export async function getStaticProps() {
  const queryClient = new QueryClient()
  await prefetchInfiniteReviews({ queryClient })
  await prefetchTotalUsers({ queryClient })
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      revalidate: 3600,
    },
  }
}

export default Opiniones
